import { render, staticRenderFns } from "./CoolMathOverlay.vue?vue&type=template&id=51391766&"
import script from "./CoolMathOverlay.vue?vue&type=script&lang=js&"
export * from "./CoolMathOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CoolMathOverlay.vue?vue&type=style&index=0&id=51391766&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports